var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "template-selcte-dialog",
      attrs: { title: _vm.title, visible: _vm.visible, width: "400px" },
      on: { close: _vm.handleClose }
    },
    [
      _c(
        "div",
        { staticStyle: { height: "100px", "overflow-y": "scroll" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value,
                callback: function($$v) {
                  _vm.value = $$v
                },
                expression: "value"
              }
            },
            _vm._l(_vm.options, function(option) {
              return _c(
                "el-radio",
                { key: option.key, attrs: { label: option.key } },
                [_vm._v(_vm._s(option.name))]
              )
            }),
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "15px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-col",
            {
              staticStyle: { "text-align": "center" },
              attrs: { span: 18, offset: 3 }
            },
            [
              _c(
                "span",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.Confirm2")))]
                  ),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("Message.Cancel2")))
                  ])
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }